// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swap-btn[data-v-70317107]{border:1px solid #c8c8d4;width:30px;height:30px}.swap-btn div[data-v-70317107]{line-height:0}.swap-btn__arrow[data-v-70317107]{color:var(--color-neutral-500)}", ""]);
// Exports
module.exports = exports;
